import StyledCollapse from "../StyledCollapse/StyledCollapse";
import {useTheme} from "../../../contexts/theme";
import Grid from "@mui/material/Grid";
import React, {useState} from "react";
import {Box, FormControlLabel} from "@mui/material";
import StyledCheckBox from "../StyledCheckbox/StyledCheckBox";
import SocialSelection from "../SocialSelection/SocialSelection";
import {Option} from "../../../types/generic";
import {SocialPlatformOptionObject} from "../../../types/socialTypes";

interface AutoPublicationProps {
    onClose?: () => void;
    onOpen?: () => void;
    enableAutoPublication: boolean;
    enableAutoPublicationAllEvents: boolean;
    handleChangeEnableAutoPublication: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleChangeEnableAutoPublicationAllEvents: (event: React.ChangeEvent<HTMLInputElement>) => void;
    homeTeamAutoPublication: boolean;
    awayTeamAutoPublication: boolean;
    handleChangeHomeTeamAutoPublication: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleChangeAwayTeamAutoPublication: (event: React.ChangeEvent<HTMLInputElement>) => void;
    socialPlatform: Option | null,
    socialPostType: Option | null,
    socialAccount: Option | null,
    onSocialPlatformChange: (selectedSocialPlatform: Option | null) => void,
    onSocialPostTypeChange: (selectedSocialPostType: Option | null) => void,
    onSocialAccountChange: (selectedSocialAccount: Option | null) => void,
    loadSocialOptions?: boolean
    socialOptions?: SocialPlatformOptionObject
}

const AutoPublication = ({socialOptions, loadSocialOptions = true, onOpen = () => {}, onClose = () => {}, enableAutoPublication, handleChangeEnableAutoPublication, handleChangeEnableAutoPublicationAllEvents, enableAutoPublicationAllEvents, handleChangeHomeTeamAutoPublication, homeTeamAutoPublication, handleChangeAwayTeamAutoPublication, awayTeamAutoPublication, onSocialPlatformChange, onSocialPostTypeChange, socialPlatform, socialPostType, socialAccount, onSocialAccountChange} : AutoPublicationProps) => {
    const theme = useTheme();

    return (
        <Box display={'flex'} flexDirection={'column'}>
            <Box>
                <StyledCollapse onClose={onClose} onOpen={onOpen} title={'Social Auto Publication'}>
                    <Grid container spacing={2} alignItems={'center'}>
                        <Grid item xs={12} md={6} lg={3}>
                            <FormControlLabel
                                sx={{color: theme.palette.white, marginLeft: '0px'}}
                                control={
                                    <StyledCheckBox
                                        height={'20px'}
                                        width={'20px'}
                                        iconSize={'20px'}
                                        checked={enableAutoPublication}
                                        onChange={(e) => handleChangeEnableAutoPublication(e as any) }
                                    />
                                }
                                label={'Enable Auto Publication'}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={5}>
                            <FormControlLabel
                                disabled={!enableAutoPublication}
                                sx={{
                                    // always keep the non‐disabled label white
                                    '& .MuiFormControlLabel-label': {
                                        color: theme.palette.white,
                                    },
                                    // when the root has the disabled class, override the label color
                                    '&.Mui-disabled .MuiFormControlLabel-label': {
                                        color: theme.palette.lightGrey,
                                    },
                                    marginLeft: 0,
                                }}
                                control={
                                    <StyledCheckBox
                                        height={'20px'}
                                        width={'20px'}
                                        iconSize={'20px'}
                                        checked={enableAutoPublicationAllEvents}
                                        onChange={(e) => handleChangeEnableAutoPublicationAllEvents(e as any)}
                                    />
                                }
                                label={'Enable Auto Publication for all selected events'}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                            <FormControlLabel
                                disabled={!enableAutoPublication}
                                sx={{
                                    color: theme.palette.white,
                                    marginLeft: '0px',
                                    '&.Mui-disabled .MuiFormControlLabel-label': {
                                        color: theme.palette.lightGrey,
                                    }
                                }}
                                control={
                                    <StyledCheckBox
                                        height={'20px'}
                                        width={'20px'}
                                        iconSize={'20px'}
                                        checked={homeTeamAutoPublication}
                                        onChange={(e) => handleChangeHomeTeamAutoPublication(e as any)}
                                    />
                                }
                                label={'Home Team'}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                            <FormControlLabel
                                disabled={!enableAutoPublication}
                                sx={{
                                    color: theme.palette.white,
                                    marginLeft: '0px',
                                    '&.Mui-disabled .MuiFormControlLabel-label': {
                                        color: theme.palette.lightGrey,
                                    }
                                }}
                                control={
                                    <StyledCheckBox
                                        height={'20px'}
                                        width={'20px'}
                                        iconSize={'20px'}
                                        checked={awayTeamAutoPublication}
                                        onChange={(e) => handleChangeAwayTeamAutoPublication(e as any)}
                                    />
                                }
                                label={'Away Team'}
                            />
                        </Grid>
                    </Grid>
                    {enableAutoPublication && (
                    <Box sx={{padding: theme.spacing.md}}>
                        <SocialSelection
                            socialAccount={socialAccount}
                            socialPostType={socialPostType}
                            socialPlatform={socialPlatform}
                            onSocialPostTypeChange={onSocialPostTypeChange}
                            onSocialPlatformChange={onSocialPlatformChange}
                            onSocialAccountChange={onSocialAccountChange}
                            localSocialOptions={socialOptions}
                            remoteLoadSocialOptions={loadSocialOptions}
                        />
                    </Box>
                    )}
                </StyledCollapse>
            </Box>

        </Box>
    );
}

export default AutoPublication;